import {LoadingOutlined} from '@ant-design/icons';
import './loaders.scss';
import {Spin} from 'antd';
import {permColors} from '../../utils/colors';
export default function Loading() {
	return <Spin rootClassName="bg-white text-linkBlue" fullscreen indicator={<LoadingOutlined style={{color: permColors.linkBlue, fontSize: '56px'}} />} />;
}
